export const MOPLA_SOLUTIONS_HOME_URL = 'https://www.mopla.solutions/';

export const MOPLA_SOLUTIONS_FAQ_URL = 'https://www.mopla.solutions/de/faq';

export const DEUTSCHLANDTARIFVERBUND_URL =
	'https://www.deutschlandtarifverbund.de';
